// Lead "temperature" derived from the AI conversion score (0-100).
export function temperature(score) {
  if (typeof score !== "number") return null;
  if (score >= 66) return { key: "chaud", label: "Chaud", cls: "text-rose-600 bg-rose-500/10" };
  if (score >= 33) return { key: "tiede", label: "Tiède", cls: "text-amber-600 bg-amber-500/10" };
  return { key: "froid", label: "Froid", cls: "text-sky-600 bg-sky-500/10" };
}
